export default [
    {
        path: '/ayarlar',
        name: 'ayarlar',
        component: () => import('../views/sett/index'),
        meta: { resource: 'admin|dealer|tech|callcenter|personel' },
        children: [
            {
                path: 'panel-ayarlari',
                name: 'panel-ayarlari',
                meta: { resource: 'admin|dealer|tech|callcenter|personel' },
                component: () => import('../views/sett/panel')
            },
        ]
    },
    {
        path: '/kullanici-yonetimi',
        name: 'kullanici-yonetimi',
        meta: { resource: 'admin' },
        component: () => import('../views/sett/users')
    },
    {
        path: '/sms-yonetimi', 
        name: 'sms-yonetimi', 
        meta: { resource: 'admin' },
        component: () => import('../views/sett/sms')
    },
    {
        path: '/yetkilendirmeler', 
        name: 'yetkilendirmeler', 
        meta: { resource: 'admin' },
        component: () => import('../views/sett/yetkilendirmeler')
    },
]
